import { RepositoryFactory } from "@/Apicall/masters/RepositoryFactory";
const studio = RepositoryFactory.get("studio");
const billing = RepositoryFactory.get("billing");


export default {
  getServices({commit},payload){
       return new Promise(async (resolve, reject) => {
      try {
        const { data } = await studio.getCARDOPTIONS(
          payload
        );
        commit("GET_CARD_OPTIONS", data.data);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  createOrder({commit},payload){
    return new Promise(async (resolve, reject) => {
      try {
      
        const { data } = await billing.createOrder(
          payload
        );
         commit("CREATE_ORDER", data.data);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  createRequest({commit},payload){
    return new Promise(async (resolve, reject) => {
      try {
     
        const { data } = await studio.createRequest(
          payload
        );
         commit("CREATE_REQUEST", data.data);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getRequest({commit},payload){
    return new Promise(async (resolve, reject) => {
      try {
     
        const { data } = await studio.getRequest(
          payload
        );
        commit("GET_REQUEST", data.data);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getSelectedRequest({commit},payload){
    return new Promise(async (resolve, reject) => {
      try {
    
        const { data } = await studio.getRequest(
          payload
        );
        // console.log(data.data.data[0],"studio data")
        commit("SELECTED_REQUEST", data.data.data[0]);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  editRequest({commit},payload){
    return new Promise(async (resolve, reject) => {
      try {
     
        const { data } = await studio.editRequest(
          payload
        );
        
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

   addComments({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        
        const { data } = await studio.addComments(
          payload
        );
        commit("ADD_COMMENTS", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getComments({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
       
        const { data } = await studio.getComments(
          payload
        );
        commit("GET_COMMENTS", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getCoupons({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
      
        const { data } = await studio.getCoupons(
          payload
        );
        commit("GET_COUPONS", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  submitCoupon({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
      
        const { data } = await studio.submitCoupon(
          payload
        );
       
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  editCoupon({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
      
        const { data } = await studio.editCoupon(
          payload
        );
       
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  editLoggedUser({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
      
        const { data } = await studio.editLoggedUser(
          payload
        );
       
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  
};
